import { v1ApiClient } from '@/services';
import type { Operation } from '@/shared/api/generated';

type DeleteReportOperation = Operation<'DeleteReport'>;

export type DeleteReportParams = DeleteReportOperation['parameters']['path'];

export const deleteReport = ({ report_id }: DeleteReportParams) =>
  v1ApiClient.delete(`/reports/${report_id}`).then((res) => res.data);
